var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"step-restricoes"},[_c('Restricao',{attrs:{"item":_vm.item,"regioesRepresentantes":_vm.regioesRepresentantes}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }